'use client';
import { useState } from 'react';

import { YOUTUBE_NOCOOKIE_HOST } from '@core/Constants/YouTube.constants';
import { Grid } from '@gds/Grid/Grid';
import { Typography } from '@gds/Typography/Typography';

import type { EmbeddedVideoElementProperties } from './EmbeddedVideo.entity';

import styles from './EmbeddedVideo.module.css';

const getYoutubeVideoId = (url: string | null) => {
  if (!url) return null;
  try {
    return new URL(url).searchParams.get('v');
  } catch {
    return null;
  }
};

export const EmbeddedVideo = ({ headline, youtubeVideoUrl }: EmbeddedVideoElementProperties) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = getYoutubeVideoId(youtubeVideoUrl);

  if (!videoId) return null;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault();
    setIsPlaying(true);
  };

  return (
    <Grid.Row className="blogCmpnt" justify="center">
      <Grid.Col width={{ mobile: 12, tablet: 12, desktop: 8 }}>
        <Typography variant="h2">{headline}</Typography>
        <div className={styles.video}>
          {isPlaying ? (
            <iframe
              src={`${YOUTUBE_NOCOOKIE_HOST}/embed/${videoId}?autoplay=1`}
              title={headline ?? ''}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          ) : (
            <button type="button" onClick={handleClick} className={styles.overlay}>
              <img
                src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                width="100%"
                alt={headline ?? ''}
              />
              <span className={styles.button}>
                <svg
                  height="100%"
                  version="1.1"
                  viewBox="0 0 68 48"
                  width="100%"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    className="ytp-large-play-button-bg"
                    d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                    fill="#f00"
                  />
                  <path d="M 45,24 27,14 27,34" fill="#fff" />
                </svg>
              </span>
            </button>
          )}
        </div>
      </Grid.Col>
    </Grid.Row>
  );
};

EmbeddedVideo.displayName = 'EmbeddedVideo';
